// extracted by mini-css-extract-plugin
export default {"gallery-setting":"App_gallery-setting__ZV9Hc"};